<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
import detailsVue from "../commondescr/details.vue";
import AddMeetingGroup from "./operate/addMeetingGroup.vue";
export default {
  extends: baseList,
  components: {
    detailsVue,
    AddMeetingGroup,
  },
  data() {
    return {
      table: {
        mname: "",
        key: "id",
        url: {
          list: "/admin/system/meetingClass/list",
        },
        output: false,
      },
      query: {},
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "system/MeetingGroup/index",
        },
      ],
      menus: [
        {
          label: "会议组",
          name: "MeetingGroup",
          auth: "system/MeetingGroup/index",
        },
      ],
      filters: [
        /*  {
          label: "地址",
          name: "building",
          value: "",
          KeyEnter: this.search,
          type: "input",
        }, */
        {
          label: "会议组名称",
          name: "className",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "会议组名称",
          key: "className",
          width: "150px",
          align: "center",
          tooltip: "true",
        },
        {
          title: "会议人员",
          key: "userNameList",
          minWidth: 0,
          align: "left",
          tooltip: "true",
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <div>
                  <Button
                    size="small"
                    onClick={() => this.toEdit(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginRight: "10px",
                    }}
                  >
                    编辑
                  </Button>
                  <Button
                    size="small"
                    onClick={() => this.delItem(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                    }}
                  >
                    删除
                  </Button>
                </div>
              );
            },
          ],
        },
      ],
      selectList: [],
      selectItem: "",
    };
  },
  created() {},
  methods: {
    onCancel() {
      this.$Modal.remove();
      this.search();
    },
    toEdit(currentRow) {
      this.$Modal.success({
        closable: true,
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <AddMeetingGroup
                onOnCancel={() => {
                  this.onCancel();
                }}
                type="edit"
                id={currentRow.id}
              />
            </div>
          );
        },
      });
    },
    toAdd() {
      this.$Modal.success({
        closable: true,
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <AddMeetingGroup
                onOnCancel={() => {
                  this.onCancel();
                }}
                type="add"
              />
            </div>
          );
        },
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(
        `/admin/system/meetingClass/del/${row.id}`,
        d,
        "DELETE"
      );
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          this.search();
        }, 100);
      }
    },
    
  },
};
</script>
<style scoped></style>
